<template>
    <div>
        <v-container class="grey lighten-5" fluid>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Dane oferty</v-card-title>
                        <v-card-text>
                            <em>Funkcjonalność jeszcze nie gotowa.</em>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h4>
                        Wyślij e-mail do autora oferty
                    </h4>
                    <v-card class="mt-3">
                        <v-card-text>
                            <!-- To get all available templates set :templates-to-list="[]". -->
                            <!-- To make the field empty set :templates-to-list="['']". -->
                            <SendEmail class="mt-3"
                                       v-if="isAdmin() || isTrader()"
                                       :receiver-entity-id="id"
                                       receiver-entity-name="BuyProposal"
                                       :templates-to-list="[
                             'client_buy_proposal_added',
                         ]"
                            ></SendEmail>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import api from '../services/api';
import SendEmail from "@/components/SendEmail";
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";

export default {
    components: {
        SendEmail,
    },
    mixins: [
        formatters,
        permissions,
    ],
    props: ['id'],
    savedBuyOfferDetails: null,
    data() {
        return {
            loading: false,
            loadingBuyOfferDetails: false,
            rawBuyOfferDetails: [],
        }
    },
    computed: {
        buyOfferDetails() {

            return {}
        },
    },
    methods: {
        async loadDetails() {
            this.loadingBuyOfferDetails = true;

            let response;

            try {
                response = await api.get(`/api/buy-proposals/${this.id}`);
            } catch (error) {
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się wczytać danych oferty kupna.',
                    error,
                });

                return;
            }

            this.loadingBuyOfferDetails = false;

            this.rawBuyOfferDetails = response.data;
            this.savedBuyOfferDetails = JSON.parse(JSON.stringify(this.buyOfferDetails));
        },
        async created() {
            try {
                await this.loadDetails();
            } catch (e) {
                console.error(e);
            }
        },
    },

}
</script>